 import './DetailsHeader.scss';

import { useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { openDrawer } from "../../../slices/drawerSlice";

import Update from "@mui/icons-material/Update";

import { LargeTitle } from "../../../common-components/Titles/Titles";
import { Button } from "../../../common-components/Buttons/Buttons";

import DeparturesReportUpdate from "../../../departures/components/DeparturesReportUpdate/DeparturesReportUpdate";
import DeparturesReportUpdateFooter from "../../../departures/components/DeparturesReportUpdate/components/DeparturesReportUpdateFooter/DeparturesReportUpdateFooter";

const DetailsHeader = ({id}) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.user.data);
    const role = data?.attributes?.role_id;

    const canAddUpdate = role === "admin" || role === "branch_office_user";

    const handleOpen = () => {
        dispatch(openDrawer({content: <DeparturesReportUpdate id={id}/>, footer: <DeparturesReportUpdateFooter id={id}/>}));
    }

    return (
        <div className={"details-header"}>
            <div className={"details-header_container"}>
                <div className={"details-header_title"}>
                    <LargeTitle property={"Детальная информация"}/>
                </div>
                {canAddUpdate && (
                    <div className={"details-header_button"}>
                        <Button Icon={Update} title={"Обновить"} onClick={handleOpen}/>
                    </div>
                )}
            </div>
        </div>
    )
}

export default DetailsHeader;